import { all } from "redux-saga/effects";
import { watchDeleteScormPackage, watchFetchExportedScormPackages, watchMount, watchUnmount } from "./watchers";

export function* exportedScormPackagesSagas() {
  yield all([watchDeleteScormPackage(), watchFetchExportedScormPackages(), watchMount(), watchUnmount()]);
}
